import { z } from 'zod';

export const createUserSchema = z.object({
  username: z.string().min(1, 'validation.required'),
  email: z.string().min(1, 'validation.required').email('validation.emailInvalid'),
  password: z.string().min(1, 'validation.required'),
});

export const updateUserSchema = z.object({
  email: z.string().min(1, 'validation.required').email('validation.emailInvalid'),
});

export const resetPasswordSchema = z.object({
  password: z.string().min(1, 'validation.required'),
});
